import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export function WashCycles(): React.JSX.Element {
  const navigate = useNavigate();

  const handleAddButton = () => {
    navigate('add');
  };

  return (
    <div className='container mt-10'>
      <div className='row'>
        <div className='col-12 d-flex justify-content-end'>
          <Button variant='success' onClick={handleAddButton}>
            Hinzufügen
          </Button>
        </div>
      </div>
    </div>
  );
}
